import {
  FetchResult,
  MutationFunctionOptions,
  gql,
  useMutation,
} from '@apollo/client';

import {
  useCreateCompanyForm_createOrganization,
  useCreateCompanyForm_createOrganizationVariables,
} from './graphql-types/useCreateCompanyForm_createOrganization';

const COMPANY_FRAGMENT = gql`
  fragment useCreateCompanyForm_organizationFragment on Organization {
    _id
    name
    state
    zipCode
    website
    phoneNumber
    city
    country
    location
    profilePicture {
      _id
      imageProxy(
        input: {
          w: 288
          h: 288
          fit: "fill"
          fill: "solid"
          fillColor: "white"
        }
      )
    }
  }
`;

const CREATE = gql`
  mutation useCreateCompanyForm_createOrganization(
    $input: CreateOrganizationV2Input!
  ) {
    createOrganizationV2(input: $input) {
      ... on CreateOrganizationV2Success {
        organization {
          ...useCreateCompanyForm_organizationFragment
        }
      }
      ... on CreateOrganizationV2DuplicateNameError {
        message
      }
      ... on CreateOrganizationV2CreateNewAdminsDuplicateEmailsError {
        message
        duplicateEmails
      }
      ... on CreateOrganizationV2CreateNewAdminsInvalidInputsError {
        message
        invalidEmails
      }
    }
  }
  ${COMPANY_FRAGMENT}
`;

export const useCreateCompanyForm = (): {
  createCompany: (
    options?:
      | MutationFunctionOptions<
          useCreateCompanyForm_createOrganization,
          useCreateCompanyForm_createOrganizationVariables
        >
      | undefined
  ) => Promise<
    FetchResult<
      useCreateCompanyForm_createOrganization,
      Record<string, any>,
      Record<string, any>
    >
  >;
  isLoading: boolean;
} => {
  const [createCompany, { loading: isLoading }] = useMutation<
    useCreateCompanyForm_createOrganization,
    useCreateCompanyForm_createOrganizationVariables
  >(CREATE, {
    update(cache) {
      cache.evict({ id: 'ROOT_QUERY', fieldName: 'organizations' });
      cache.evict({ id: 'ROOT_QUERY', fieldName: 'organizationSearch' });
      cache.gc();
    },
  });

  return {
    createCompany,
    isLoading,
  };
};
